<template>
    <div>
        <div v-if="form.message.length == 0">
            <h4>
                Please complete the following
            </h4>
            <search-signup
                v-if="typeof checkin !== 'undefined' && checkin && 0"
                v-on:fill="fillData"
            ></search-signup>
            <!--  removed temporarily -->
            <form
                id="sign-up"
                @submit.prevent="onSubmit"
                @keydown="form.errors.clear($event.target.name)"
            >
                <input type="hidden" name="id" v-model="form.id" />
                <div class="field is-horizontal">
                    <div class="field-body">
                        <div class="field">
                            <label class="label">First Name</label>
                            <div class="control has-icons-right">
                                <input
                                    name="first_name"
                                    class="input"
                                    type="text"
                                    placeholder="Required"
                                    v-model="form.first_name"
                                />
                                <span class="icon is-small is-right">
                                    <i class="fas fa-exclamation-triangle"></i>
                                </span>
                            </div>
                            <span
                                class="help is-danger"
                                v-if="form.errors.has('first_name')"
                                v-text="form.errors.get('first_name')"
                            ></span>
                        </div>
                        <div class="field">
                            <label class="label">Last Name</label>
                            <div class="control">
                                <input
                                    name="last_name"
                                    class="input"
                                    type="text"
                                    v-model="form.last_name"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <!-- .is-horizontal -->
                <div class="field is-horizontal">
                    <div class="field-body">
                        <div class="field">
                            <label class="label">Email</label>
                            <div class="control has-icons-left has-icons-right">
                                <input
                                    name="email"
                                    class="input"
                                    type="email"
                                    placeholder="Required"
                                    v-model="form.email"
                                />
                                <span class="icon is-small is-left">
                                    <i class="fas fa-envelope"></i>
                                </span>
                                <span class="icon is-small is-right">
                                    <i class="fas fa-exclamation-triangle"></i>
                                </span>
                            </div>
                            <span
                                class="help is-danger"
                                v-if="form.errors.has('email')"
                                v-text="form.errors.get('email')"
                            ></span>
                        </div>
                        <div class="field">
                            <label class="label">Telephone</label>
                            <div class="control has-icons-left has-icons-right">
                                <input
                                    name="phone"
                                    class="input"
                                    type="tel"
                                    v-model="form.phone"
                                />
                                <span class="icon is-small is-left">
                                    <i class="fas fa-phone"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- .is-horizontal -->
                <div class="field">
                    <label class="label">Move in time frame</label>
                    <div class="control">
                        <label class="radio">
                            <input
                                type="radio"
                                name="time_frame"
                                value="immediate"
                                v-model="form.time_frame"
                            />
                            Right away
                        </label>
                        <label class="radio">
                            <input
                                type="radio"
                                name="time_frame"
                                value="3 months"
                                v-model="form.time_frame"
                            />
                            Within 3 months
                        </label>
                        <label class="radio">
                            <input
                                type="radio"
                                name="time_frame"
                                value="6 months"
                                v-model="form.time_frame"
                            />
                            Within 6 months
                        </label>
                        <label class="radio">
                            <input
                                type="radio"
                                name="time_frame"
                                value="1 year"
                                v-model="form.time_frame"
                            />
                            Within 1 year
                        </label>
                    </div>
                    <div class="field mt-6">
                        <div class="control">
                            <label class="checkbox">
                                <input
                                    type="checkbox"
                                    name="prequalified"
                                    value="yes"
                                    v-model="form.prequalified"
                                />
                                I have a prequalified mortgage letter or I am
                                paying cash
                            </label>
                        </div>
                    </div>
                    <div class="field">
                        <label class="label">Questions?</label>
                        <div class="control">
                            <textarea
                                name="note"
                                class="textarea"
                                placeholder=""
                                v-model="form.note"
                            ></textarea>
                        </div>
                    </div>
                </div>
                <div class="field">
                    <button
                        class="button is-primary"
                        v-text="
                            typeof checkin == 'undefined'
                                ? 'Submit'
                                : 'Check In'
                        "
                    >
                        Submit
                    </button>
                    <button
                        class="button ml-4"
                        @click="closeModal"
                        type="button"
                    >
                        Cancel
                    </button>
                </div>
            </form>
        </div>
        <div class="p-8 text-center" v-if="form.message.length">
            <h2
                class="text-3xl text-center mb-4"
                v-text="form.message"
            ></h2>
            <div
                class="text-center m-4"
                v-if="typeof checkin !== 'undefined'"
            >
                <div>
                    <a class="button is-primary" @click="refresh"
                        >Reload ( <span v-text="seconds"></span> )</a
                    >
                </div>
            </div>
            <button
                class="button is-primary"
                v-if="typeof checkin == 'undefined'"
                @click="closeModal"
            >
                Close
            </button>
        </div>
    </div>
</template>
<script>
import { Errors, Form } from "../../Form";
import SearchSignup from "./SearchSignup.vue";
var isNullOrEmpty = require("is-null-or-empty");
export default {
    props: ["checkin"],
    components: {
        SearchSignup,
        Form
    },
    methods: {
        onSubmit() {
            var url = "/property/" + slug + "/signup/";
            var self = this;
            this.form.submit("post", url, this.$data.form).then(response => {
                self.form.message = response.message;
                if (!isNullOrEmpty(self.$props.checkin)) {
                    self.reloadPointer = setInterval(function() {
                        if (self.seconds == 0) {
                            window.location.reload();
                        } else {
                            --self.seconds;
                        }
                    }, 1000);
                }
            });
        },
        refresh() {
            window.location.reload();
        },
        fillData(o) {
            this.id = o.id;
            this.first_name = o.first_name;
            this.last_name = o.last_name;
            this.phone = o.phone;
            this.note = o.note;
            this.prequalified = o.prequalified == "yes" ? true : false;
            this.time_frame = o.time_frame;
            this.email = o.email;
        },
        closeModal() {
            this.form.message = "";
            this.$modal.hide("signup-modal");
        },
        resetForm() {
            this.form = new Form({
                id: null,
                first_name: "",
                last_name: "",
                phone: "",
                note: "",
                prequalified: false,
                time_frame: null,
                email: "",
                message: ""
            });
        }
    },
    created() {
        this.resetForm();
    },
    data() {
        return {
            form: null,
            seconds: 3,
            reloadPointer: null,
            success: false
        };
    }
};
</script>
